import Lang from 'assets/Lang';
import Configs from 'utils/Configs';
import Const from 'consts/Const';

const { SALE, IMPORT, RETURN, PAYMENT_VOUCHER, RECIEPT, DEBT, IMPORT_RETURN } = Const.ORDER_TYPE;

export default {
  getFinancialInfo: (item) => {
    const { type, parentOrder, customer, paid } = item;
    const { reciept, order, importOrder, returntOrder, paymentVoucher, debt, importReturn } = Configs.prefix;
    let title = Lang.financialBook.receipts;
    const isRelateToOrder = type === SALE || type === IMPORT || type === RETURN || !!parentOrder?.id;
    let prefix = '';
    let typeName = '';
    let detailText = '';
    let relateCode = '';
    let money = paid;
    if (!Configs.online) {
      item.myId = item.id;
      if (parentOrder) parentOrder.myId = parentOrder?.id;
      if (customer) customer.myId = customer.id;
    }
    switch (type) {
      case RETURN:
        prefix = returntOrder;
        title = Lang.financialBook.moneyForReturn;
        typeName = Lang.orderType.return;
        relateCode = parentOrder?.id ? (Configs.prefix.returntOrder || '') + parentOrder?.myId : '';
        detailText = Lang.financialBook.paymentVoucherAutoGenFor;
        break;
      case IMPORT_RETURN:
        prefix = importReturn;
        title = Lang.financialBook.moneyFromReturn;
        typeName = Lang.orderType.importReturn;
        relateCode = parentOrder?.id ? (importReturn || '') + parentOrder?.myId : '';
        detailText = Lang.financialBook.receiptForOrder;
        break;
      case IMPORT:
        prefix = importOrder;
        title = Lang.financialBook.moneyForProvider;
        typeName = Lang.orderType.import;
        relateCode = parentOrder?.id ? (Configs.prefix.importOrder || '') + parentOrder?.myId : '';
        detailText = Lang.financialBook.paymentVoucherAutoGenFor;
        break;
      case RECIEPT:
        title = item.id ? Lang.financialBook.receipts : Lang.financialBook.receipt;
        prefix = reciept;
        typeName = Lang.orderType.receipt;
        detailText = parentOrder?.id ? Lang.financialBook.receiptForOrder : '';
        relateCode = parentOrder?.id ? ((parentOrder.type === 3 ? Configs.prefix.importReturn : Configs.prefix.order) || '') + parentOrder?.myId : '';
        if (!isRelateToOrder && customer?.id) {
          detailText = Lang.financialBook.receiptFromCustomer;
          relateCode = ((customer.type === 0 ? Configs.prefix.customer : Configs.prefix.provider) || '') + (customer?.myId || customer?.id);
        }
        break;
      case PAYMENT_VOUCHER:
        prefix = paymentVoucher;
        title = item.id ? Lang.financialBook.paymentVoucher : Lang.financialBook.vouchers;
        typeName = Lang.orderType.payment;
        detailText = parentOrder?.id ? Lang.financialBook.paymentForOrder : '';
        const prefix1 = parentOrder?.type === RETURN ? Configs.prefix.returntOrder : parentOrder?.type === IMPORT ? Configs.prefix.importOrder : Configs.prefix.order;
        relateCode = parentOrder?.id ? (prefix1 || '') + parentOrder?.myId : item.myId;
        if (!isRelateToOrder && customer?.id) {
          detailText = customer?.type === 0 ? Lang.financialBook.paymentForCustomer : Lang.financialBook.paymentForProvider;
          relateCode = ((customer.type === 0 ? Configs.prefix.customer : Configs.prefix.provider) || '') + (customer?.myId || customer?.id);
        }
        break;
      case DEBT:
        prefix = debt;
        title = item.id ? Lang.financialBook.debt : Lang.financialBook.createDebt;
        typeName = Lang.orderType.debt;
        money = item.money;
        break;
      case SALE:
      default:
        title = Lang.financialBook.moneyFromCustomer;
        prefix = order;
        typeName = Lang.orderType.sale;
        break;
    }
    if (item.financialType?.name) typeName = item.financialType?.name;
    const id = (prefix || '') + item.myId;
    return { typeName, prefix, title, id, money, detailText, relateCode, isRelateToOrder };
  },

  getTotalDebt(orders, customer) {
    let totalDebit = 0;
    for (let i = 0; i < orders?.length; i += 1) {
      const item = orders[i];
      let paid = item.paid;
      if (paid === null || paid === undefined) paid = item.money;
      if (item.type === SALE || !Configs.online) {
        if (customer?.type === 0 || !Configs.online) totalDebit += item.money - paid;
        else totalDebit -= item.money - paid;
      } else if (item.type === IMPORT) {
        if (customer?.type === 0) totalDebit -= item.money - paid;
        else totalDebit += item.money - paid;
      } else if (item.type === RETURN) {
        if (customer?.type === 0) totalDebit -= item.money - paid;
        else totalDebit += item.money - paid;
      } else if (item.type === IMPORT_RETURN) {
        totalDebit -= item.money - paid;
      } else if (item.type === DEBT) {
        totalDebit += item.money;
      } else if (!item.parentOrderId) {
        // Chỗ này sẽ bỏ qua những phiếu thu chi mà đã liên kết với đơn hàng
        if (item.type === RECIEPT) {
          if (customer?.type === 0) totalDebit -= item.money;
          else totalDebit += item.money;
        } else if (item.type === PAYMENT_VOUCHER) {
          // Loại này đôi khi cho đơn trả hàng (Khách hàng) hoặc đơn nhập (Nhà cung cấp)
          if (customer?.type === 0) totalDebit += item.money;
          else totalDebit -= item.money;
        }
      }
    }
    return totalDebit;
  }
};
